// @flow

import type { Node } from 'react';
import React, { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { PreloaderPage } from '@riseart/common';
import { selectPagePreloaderSubscribers } from 'shared_services/redux/selectors/gui';
import { clearPreloaderState } from 'shared_services/redux/actions/application/pagepreload';

/**
 * PagePreloader
 *
 * @returns Node
 */
export function PagePreloader(): Node {
  const dispatch: Function = useDispatch();
  const subscribers = useSelector(selectPagePreloaderSubscribers, shallowEqual);
  const actionClearPreloaderState = useCallback(() => {
    dispatch(clearPreloaderState());
  }, [dispatch]);

  return (
    <PreloaderPage
      subscribers={subscribers}
      actionClearPreloaderState={actionClearPreloaderState}
    />
  );
}
